import { useTranslation } from 'next-i18next';
import { HTMLComponentInterface } from '../../../../../interfaces/pagebuilder';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';
import HTMLFallbackValuesSelect from './HTMLFallbackValuesSelect';

interface HTMLSettingsTableInterface {
  component: HTMLComponentInterface;
  onChange: (c: HTMLComponentInterface) => void;
}

const HTMLSettingsTable = ({ component, onChange }: HTMLSettingsTableInterface) => {
  const { t } = useTranslation();

  function handleFallbackValuesChange(data: HTMLComponentInterface['fallbackValues']) {
    if (!data) return;
    const updatedValues = [...(component.fallbackValues ?? [])];

    for (const updatedValue of data) {
      const index = updatedValues.findIndex((value) => value.variable === updatedValue.variable);
      if (index >= 0) {
        updatedValues?.splice(index, 1, { variable: updatedValue.variable, value: updatedValue.value });
      } else {
        updatedValues.push(updatedValue);
      }
    }

    onChange({ ...component, fallbackValues: updatedValues });
  }

  const settingSections: PageBuilderSettingsSection[] = [
    {
      name: t('pagebuilder:component-settings'),
      toastMessage: t('pagebuilder:html-double-click-toast'),
      settings: [
        // {
        //   content: (
        //     <CustomTranslationForm
        //       defaultValue={component?.translations || []}
        //       useInternalForm={true}
        //       useRichTextInput={true}
        //       onChange={(data) => {
        //         onChange({ ...component, translations: data });
        //       }}
        //     />
        //   ),
        // },
        ...(component.content?.includes('{{')
          ? [
              {
                label: t('pagebuilder:fallback-values'),
                content: <HTMLFallbackValuesSelect onChange={handleFallbackValuesChange} component={component} />,
              },
            ]
          : []),
      ],
    },
  ];

  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} />;
};
export default HTMLSettingsTable;
